import React from 'react';
import PropTypes from 'prop-types';

import ShareIcon from '~/src/components/svg/action/Share';
import ActivityButton from '~/src/components/activity/button/ActivityButton';
import Modal from '~/src/components/modal/Modal';
import ShareModal from '~/src/components/share/shareModal/ShareModal';
import Notification from '~/src/components/notification/Notification';

import {withTypeContext} from '~/src/components/context/TypeContext';
import {ButtonFormat, ColorScheme} from '~/src/utilities/constants/formats';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18nStrings from './ShareButton.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class ShareButton extends React.Component {
    closeModal = () => {
        this.setState({showNotification: false, showShareModal: false});
    };

    showNotification = () => {
        this.setState({showNotification: true});
    };

    showShareModal = () => {
        this.setState({showShareModal: true});
    };

    handleClick = (event) => {
        event.preventDefault();

        if (this.props.isDisabled) {
            this.showNotification();
            return;
        }

        this.showShareModal();
        trackGtm(GtmEvents.INTERACTION, {
            interactionType: 'share',
            interactionSource: this.props.source,
            contentId: this.props.metadataId
        });
    };

    constructor(props) {
        super(props);

        this.state = {
            showNotification: false,
            showShareModal: false
        };
    }

    render() {
        return (
            <React.Fragment>
                <ActivityButton
                    isDisabled={this.props.isDisabled}
                    activityCount={this.props.activityCount}
                    onClick={this.handleClick}
                    format={this.props.format}
                    colorScheme={this.props.colorScheme}
                    data-testid="ButtonShare"
                >
                    <ShareIcon title={getTranslation('title')} />
                </ActivityButton>

                {this.state.showNotification && (
                    <Modal>
                        <Notification onClose={this.closeModal} message={getTranslation('sharingDisabledMessage')} />
                    </Modal>
                )}

                {this.state.showShareModal && (
                    <Modal>
                        <ShareModal onClose={this.closeModal} closeActionBubble={this.props.closeActionBubble} {...this.props} />
                    </Modal>
                )}
            </React.Fragment>
        );
    }
}

const ShareButtonLoader = ({format}) => {
    return (
        <ActivityButton activityCount="-" format={format} data-testid="ButtonShare">
            <ShareIcon />
        </ActivityButton>
    );
};

if (process.env.NODE_ENV === 'development') {
    ShareButton.propTypes = {
        activityCount: PropTypes.number,
        metadataId: PropTypes.string.isRequired,
        format: PropTypes.oneOf(Object.values(ButtonFormat)).isRequired,
        colorScheme: PropTypes.oneOf(Object.values(ColorScheme)),
        isDisabled: PropTypes.bool
    };
}

export {ShareButtonLoader};

export default withTypeContext(ShareButton);
